export var QueriesEditorEvents = {
    //raised when the data-grid is available for public access by calling getDataGrid function
    dataGridAvailable: 'grid-available',
    //raised when the data grid is going to be not available (calling getDataGrid after this event will return null)
    dataGridNotAvailable: 'grid-not-available',
    //raised when the grid is reloading
    dataGridReload: 'grid-reload',
    //called when the manage-columns changes are finished
    saveManageColumns: 'save-manage-columns',
    //raised when a column has been push in the columns collection of this editor
    columnPushed: 'column-pushed',
    //raised when all the columns pushed have been prepared to be used by the grid
    columnsPrepared: 'columns-prepared',
    //raised when a row in the grid is selected
    rowSelected: 'row-selected',
    //raised when the add entity button is called
    createEntity: 'create-entity',
    //raised when the saved selected query changed
    savedQueryChanged: 'saved-query-changed'
};
